import React from "react";
import FooterIcons from "./FooterIcons";
import FooterLinks from "./FooterLinks";
import FooterCompany from "./FooterCompnay";
import FooterStores from "./FooterStores";

function Footer() {
    return (
        <div className="footer">
            <div className="footer__container footer__desktop">
                <FooterStores />
                <div className={"footer__topLine"}>
                    <FooterIcons />
                    <FooterLinks />
                    <FooterCompany />
                </div>
            </div>

            <div className="footer__mobile">
                <FooterStores />
                <div className={"mobile-section"}>
                    <FooterIcons />
                    <FooterCompany />
                </div>
                <FooterLinks />
            </div>
        </div>
    );
}

export default Footer;
